<ng-container *ngIf="control.errors as err">
  <ul>
    <li *ngIf="err.required">
      <span>{{ err.required.message || 'Campo obbligatorio' }}</span>
    </li>
    <li *ngIf="err.min">
      <span>{{ 'Il campo non può essere minore di ' + err.min.min }}</span>
    </li>
    <li *ngIf="err.pattern">
      <span>{{ err.pattern.message || 'Campo non valido' }}</span>
    </li>
    <li *ngFor="let additionalError of additionalErrors | keyvalue">
      <span>{{ additionalError?.value?.status || 'Campo non valido' }}</span>
      <i *ngIf="additionalError?.value?.message" class="bi bi-question-circle message-icon" placement="bottom"
         [ngbTooltip]="additionalError?.value?.message" [openDelay]="0" [closeDelay]="0"></i>
    </li>
  </ul>
</ng-container>
